
    import { computed, defineComponent, ref } from 'vue'
    import { useRoute, useRouter } from 'vue-router/composables'

    import HeaderMainTitle from '@/app/components/header/HeaderMainTitle.vue'
    import HeaderNav from '@/app/components/header/HeaderNav.vue'
    import HeaderSearch from '@/app/components/header/HeaderSearch.vue'
    import { useBreadcrumbsStore } from '@/app/stores/breadcrumbs'
    import { useSearchStore } from '@/app/stores/search'

    import { useHydrationFix } from '@/common/composables/hydration-fix'
    import { useVuetify } from '@/common/composables/libs/vuetify'
    import { breadcrumbsList, header } from '@/common/json-ld/page-elements'

    export default defineComponent({
        components: {
            HeaderMainTitle,
            HeaderNav,
            HeaderSearch
        },
        setup () {
            const route = useRoute()
            const router = useRouter()
            const vuetify = useVuetify()

            const breadcrumbsStore = useBreadcrumbsStore()
            const searchStore = useSearchStore()
            const { isHydrated } = useHydrationFix()

            const mobileNav = ref(false)

            const breadcrumbs = computed(() => breadcrumbsStore.breadcrumbs)
            const breadcrumbsJsonLd = computed(() => breadcrumbsList(breadcrumbs.value))

            const showMobileNavButton = computed((): boolean => {
                return isHydrated.value ? vuetify.breakpoint.mdAndDown : false
            })

            const showNav = computed((): boolean => {
                return isHydrated.value ? vuetify.breakpoint.lgAndUp || mobileNav.value : true
            })

            const search = async (): Promise<void> => {
                const query = searchStore.query

                // Route name check is needed in order to prevent NavigationDuplicated error
                // Query check is needed for guard check to not fail, query should not be empty
                if (route.name !== 'search' && query !== '') {
                    await router.push({
                        name: 'search',
                        params: {
                            query: query
                        }
                    })
                }
            }

            return {
                breadcrumbs,
                breadcrumbsJsonLd,
                headerJsonLd: header,
                mobileNav,
                showMobileNavButton,
                showNav,
                search
            }
        }
    })
